import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { Product } from '@/types'

import { getFeaturedProducts } from '@/lib/products'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'
import HomeHero from '@/components/landing/home-hero'
import Meaning from '@/components/landing/meaning'
import ProcessStory from '@/components/landing/process-story'
import FeaturedProducts from '@/components/landing/featured-products'
import WorkshopInvite from '@/components/landing/workshop-invite'
import CraftStory from '@/components/landing/craft-story'

interface HomeProps {
    featured: Array<Product>
}

const Home: FC<HomeProps> = ({ featured }): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HomeHero />
            <Meaning />
            <ProcessStory />
            <FeaturedProducts products={featured} />
            <WorkshopInvite />
            <CraftStory />
        </Layout>
    )
}

export const getServerSideProps: GetServerSideProps<HomeProps> = async ({ res }) => {
    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=300')

    try {
        const featured = await getFeaturedProducts(4)
        return { props: { featured } }
    } catch (error) {
        console.error('Featured products could not be loaded', error instanceof Error ? error.message : error)
        return { props: { featured: [] } }
    }
}

export default Home
